import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import jsonp from 'jsonp';
import { debounce } from 'throttle-debounce';
import MdUnfoldMore from 'react-icons/lib/md/unfold-more';
import MdUnfoldLess from 'react-icons/lib/md/unfold-less';

import * as seatics from '../../../helpers/seatics';

import Spinner from '../../ui/Spinner';

import Sidebar from './Sidebar';
import TicketList from './Sidebar/TicketList';

import * as styles from './styles';

const Container = glamorous.div(styles.Container);
const MapContainer = glamorous.div(styles.MapContainer);
const ShowVenueMap = glamorous.div(styles.ShowVenueMap);
const HideVenueMap = glamorous.div(styles.HideVenueMap);

const styleShowMapIcon = {
  position: 'absolute',
  right: 8,
  top: '50%',
  transform: 'translateY(-50%)',
  width: 32,
};

const noop = () => {};

class SeaticsMapWidget extends React.PureComponent {
  static propTypes = {
    // Added injectable nav and footer to test mapHeight function
    nav: PropTypes.object,
    footer: PropTypes.object,
    seaticsFilterOptions: PropTypes.shape({
      defaultSort: PropTypes.string,
    }),

    onNoEvent: PropTypes.func,
    onNoTickets: PropTypes.func,
    onSeaticsEvent: PropTypes.func,
    onSelectTicket: PropTypes.func,

    hasFilters: PropTypes.bool,
    hasSort: PropTypes.bool,
    hasTaraFilters: PropTypes.bool,
    hasTicketAttributes: PropTypes.bool,
    isFetching: PropTypes.bool,

    eventId: PropTypes.string,
    defaultSort: PropTypes.string,
    deliveryType: PropTypes.string,
    price: PropTypes.string,
    quantity: PropTypes.string,
    ticketType: PropTypes.string,

    eventHeaderHeight: PropTypes.number,
  };

  static defaultProps = {
    nav: undefined,
    footer: undefined,

    seaticsFilterOptions: {
      defaultSort: 'PriceAsc',
    },

    onNoEvent: noop,
    onNoTickets: noop,
    onSeaticsEvent: noop,
    onSelectTicket: noop,

    hasFilters: false,
    hasSort: false,
    hasTaraFilters: false,
    hasTicketAttributes: false,
    isFetching: false,

    eventId: undefined,
    defaultSort: undefined,
    deliveryType: undefined,
    price: undefined,
    quantity: undefined,
    ticketType: undefined,

    eventHeaderHeight: 0,
  };

  state = {
    isReady: false,
    filterOptions: {},
    sortOptions: {},
    selectedTicket: null,
    mapHeight: this.getMapHeight(),
  };

  componentDidMount() {
    this.hasMounted = true;

    this.loadScripts();

    setTimeout(this.getAndSetMapHeight, 100);

    window.addEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    const { Seatics } = window;

    if (!Seatics || !Seatics.MapComponent) {
      return null;
    }

    const {
      eventHeaderHeight,
      seaticsFilterOptions,
    } = nextProps;

    if (nextProps.ticketList !== this.props.ticketList) {
      this.setTicketList(nextProps.ticketList);
    }

    if (seaticsFilterOptions !== this.props.seaticsFilterOptions) {
      this.setMapSortAndFilterOptions(seaticsFilterOptions);
    }

    if (eventHeaderHeight !== this.props.eventHeaderHeight) {
      setTimeout(this.getAndSetMapHeight, 100);
    }
  }

  componentWillUnmount() {
    this.hasMounted = false;

    window.removeEventListener('resize', this.handleResize);
  }

  getMapHeight() {
    return seatics.getMapHeight(this.props.nav, this.props.footer, this.props.eventHeaderHeight);
  }

  setSelectedTicket = selectedTicket => this.setState({ selectedTicket });
  setMapHeight = (mapHeight) => (this.hasMounted ? this.setState({ mapHeight }) : null);

  setTicketList = (ticketList) => {
    const { Seatics } = window;

    if (!Seatics || !Seatics.MapComponent || !Seatics.MapComponent.addTicketData) {
      return null;
    }

    window.Seatics.MapComponent.addTicketData([]);
    setTimeout(() => {
      const ticketData = seatics.normalizeTicketData(ticketList);
      window.Seatics.MapComponent.addTicketData(ticketData);
    }, 400);
  };

  setMapSortAndFilterOptions = (seaticsFilterOptions) => {
    const { Seatics } = window;

    if (!Seatics || !Seatics.MapComponent || !Seatics.MapComponent.setFilterOptions) {
      return null;
    }

    const {
      sortType,
    } = seaticsFilterOptions;

    const filterOptions = {
      sortType: window.Seatics.SortOptions[sortType],
    };

    window.Seatics.MapComponent.setFilterOptions(filterOptions);
  };

  getAndSetMapHeight = () => {
    const mapHeight = this.getMapHeight();
    this.setMapHeight(mapHeight);
    this.resizeMap();
  };


  loadScripts() {
    if (!this.hasMounted) {
      return null;
    }

    const config = {
      defaultSort: this.props.seaticsFilterOptions.sortType,
    };

    seatics.setSeaticsMapConfig(config);
    window.Seatics.TrackingEvents.registerEventListener(this.handleSeaticsEvent);

    const eventScriptUrl = seatics.getEventScriptUrl(this.props.eventId);
    jsonp(eventScriptUrl, null, this.handleEventScriptLoaded);
  }

  resizeMap() {
    const { Seatics } = window;

    if (Seatics && Seatics.MapComponent && Seatics.MapComponent.resize) {
      Seatics.MapComponent.resize();
    }
  }

  parseQuantity(param) {
    const quantity = seatics.parseQuery(param);

    if (quantity === 'any') {
      return undefined;
    }

    return quantity;
  }

  createMapComponent = (data) => {
    const ticketListContainer = window.$('#ticketsListDiv');
    const container = window.$('#map-list-holder');
    const ticketData = seatics.normalizeTicketData(this.props.ticketList);
    const eventData = data[0];
    const mapData = data[1];

    const rowProps = {
      onSelectTicket: this.handleSelectTicket,
      hasTicketAttributes: this.props.hasTicketAttributes,
    };

    const updateTicketsList = tdSegmented => TicketList.update(ticketListContainer, tdSegmented, rowProps);

    window.Seatics.MapComponent.create({
      imgSrc: eventData.mapImage,
      tickets: ticketData,
      mapData,
      vfsUrl: 'https://vfs.seatics.com',
      container,
      presentationInterface: {
        updateTicketsList,
      },
      mapWidth: 500,
      mapHeight: this.getMapHeight(),
      mapName: eventData.mapName,
      enableSectionInfoPopups: true,
    });

    window.Seatics.MapComponent.onTicketListDrawn();
    this.setMapSortAndFilterOptions(this.props.seaticsFilterOptions);

    this.setState({
      sortOptions: window.Seatics.SortOptions,
      isReady: true,
    });
  };

  handleEventScriptLoaded = (err, data) => {
    if (!this.hasMounted) {
      return null;
    }

    if (err) {
      console.error(err.message);
    } else {
      this.createMapComponent(data);
    }
  };

  handleHideCheckout = () => {
    this.setSelectedTicket(null);
  };

  handleResize = debounce(300, true, (e) => {
    setTimeout(this.getAndSetMapHeight, 250);
  });

  handleSeaticsEvent = (type, data) => {
    this.props.onSeaticsEvent(type, data);
  };

  handleSelectTicket = (ticket) => {
    this.props.onSelectTicket(ticket);
    this.setSelectedTicket(ticket);
  };

  render() {
    const {
      selectedTicket,
      sortOptions,
    } = this.state;

    return (
      <Container
        id="map-list-holder"
        height={this.state.mapHeight}
        isFetching={this.props.isFetching}
        isViewingMap={this.props.isViewingMap}
        selectedTicket={selectedTicket}
      >
        <MapContainer
          isViewingMap={this.props.isViewingMap}
        >
          <div
            id="venue-map"
            className="venue-map"
            style={{overflow: 'visible', width: '100%', height: '100%'}}
          />
          <Spinner
            isReady={this.props.mapStatus === 'READY'}
          />
        </MapContainer>

        <ShowVenueMap
          isViewingMap={this.props.isViewingMap}
          onClick={this.props.onClickToggleMap}
          selectedTicket={selectedTicket}
        >
          Show Venue Map {!this.props.isViewingMap && (<MdUnfoldMore size={24} style={styleShowMapIcon} />)}
        </ShowVenueMap>

        <HideVenueMap
          isViewingMap={this.props.isViewingMap}
          onClick={this.props.onClickToggleMap}
          selectedTicket={selectedTicket}
        >
          <MdUnfoldLess size={24} />
        </HideVenueMap>

        <Sidebar
          currentFilters={this.props.currentFilters}
          eventName={this.props.name}
          venue={this.props.venue}
          hasFilters={this.props.hasFilters}
          hasSort={this.props.hasSort}
          hasTaraFilters={this.props.hasTaraFilters}
          hasTicketAttributes={this.props.hasTicketAttributes}
          isFetching={this.props.isFetching}
          isReady={this.props.mapStatus === 'READY'}
          isViewingMap={this.props.isViewingMap}
          onChangeSort={this.props.onChangeSort}
          onClickBuyButton={this.props.onClickBuyButton}
          onClickFilters={this.props.onClickFilters}
          onHide={this.handleHideCheckout}
          onSelectTicket={this.handleSelectTicket}
          selectedTicket={this.state.selectedTicket}
          hasNoRecommendedTickets={this.props.hasNoRecommendedTickets}
          shouldShowAllTickets={this.props.shouldShowAllTickets}
          sortOptions={sortOptions}
          ticketList={this.props.ticketList}
          seaticsFilterOptions={this.props.seaticsFilterOptions}
        />
      </Container>
    );
  }
}

export default SeaticsMapWidget;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/SeaticsMapWidget.js